export const BUNKERING_LOGS_NS = 'components/BunkeringLogs';

export const i18n = {
  en: {
    modals: {
      export: {
        title: 'You are about to export the bunkering logs',
        message:
          'If you have selected any filters in the bunkering logs screen, these will be applied to your exported data.',
        exportingMessage: 'Exporting data...',
        confirmText: 'Export',
        cancelText: 'Cancel',
        error: {
          message: 'Failed to export the file.',
        },
      },
    },
  },
};
